import { memo, ChangeEvent, FC, Dispatch, SetStateAction } from 'react'
import { Select, Skeleton } from '@chakra-ui/react'

import { ActivityType } from 'Activities/types'

type Props = {
  name?: string
  loadingActivitiesTypes: boolean
  activitiesTypes: ActivityType[]
  filter: any
  setFilter: Dispatch<SetStateAction<any>>
}

const ActivitiesTypesSelectInList: FC<Props> = ({
  name = 'activity_type_id',
  filter,
  setFilter,
  activitiesTypes,
  loadingActivitiesTypes,
}) => {
  function onSelectActivityType(event: ChangeEvent<HTMLSelectElement>) {
    const filteredActivitiesTypes: string[] = filter[name]
    const newActivityTypeName: string = event.target.value
    setFilter({ ...filter, [name]: [...filteredActivitiesTypes, newActivityTypeName] })
  }

  return (
    <Skeleton isLoaded={!loadingActivitiesTypes}>
      <Select placeholder="Selecione os tipos de atividades" value={filter[name]} onChange={onSelectActivityType}>
        {activitiesTypes.map(({ id, name }) => (
          <option key={id} value={id}>
            {name}
          </option>
        ))}
      </Select>
    </Skeleton>
  )
}

export default memo(ActivitiesTypesSelectInList)
